import React from 'react';
import PropTypes from 'prop-types';
import {
  CheckCircle,
  GpsFixed,
  GpsOff,
  Report,
  Warning,
  Wifi,
  WifiOff,
} from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { statusColorObj } from '../../../../themes';
import CustomTooltip from '../CustomTooltip';

const AssetIcon = ({ status, includeTooltip, measuringMode, dark }) => {
  const { t } = useTranslation();
  const statusTxt = (status || '').toLowerCase();
  let icon = null;

  const shadowStyle = `drop-shadow( 1px 1px 1px rgba(0, 0, 0, .7)) ${
    dark ? '' : 'brightness(1.75)'
  }`;

  switch (statusTxt) {
    case 'warning':
      icon = (
        <Warning
          sx={{
            color: statusColorObj.warning,
            WebkitFilter: shadowStyle,
            filter: shadowStyle,
          }}
        />
      );
      break;
    case 'danger':
      icon = (
        <Report
          sx={{
            color: statusColorObj.danger,
            WebkitFilter: shadowStyle,
            filter: shadowStyle,
          }}
        />
      );
      break;
    case 'normal':
      icon = (
        <CheckCircle
          sx={{
            color: statusColorObj.normal,
            WebkitFilter: shadowStyle,
            filter: shadowStyle,
          }}
        />
      );
      break;
    case 'on':
      icon =
        measuringMode === 'positioning' ? (
          <GpsFixed
            sx={{
              color: statusColorObj.primary,
              WebkitFilter: shadowStyle,
              filter: shadowStyle,
            }}
          />
        ) : (
          <Wifi
            sx={{
              color: statusColorObj.primary,
              WebkitFilter: shadowStyle,
              filter: shadowStyle,
            }}
          />
        );
      break;
    default:
      icon =
        measuringMode === 'positioning' ? (
          <GpsOff
            sx={{
              color: statusColorObj.off,
              WebkitFilter: shadowStyle,
              filter: shadowStyle,
            }}
          />
        ) : (
          <WifiOff
            sx={{
              color: statusColorObj.off,
              WebkitFilter: shadowStyle,
              filter: shadowStyle,
            }}
          />
        );
  }
  if (includeTooltip) {
    return (
      <CustomTooltip
        title={t(`components.location.status.${statusTxt.toUpperCase()}`)}
      >
        {icon}
      </CustomTooltip>
    );
  }
  return icon;
};

AssetIcon.defaultProps = {
  includeTooltip: false,
  dark: false,
};

AssetIcon.propTypes = {
  status: PropTypes.string.isRequired,
  measuringMode: PropTypes.string,
  includeTooltip: PropTypes.bool,
  dark: PropTypes.bool,
};

export default AssetIcon;
